import RowPerPage from './RowPerPage'

export default RowPerPage
